import { JVDropdown } from "../../../shared/JVDropdown";
import { useForm } from 'react-hook-form';
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { JVInput } from "../../../shared/JVInput";
import { IPurchaseOrder } from "../../../models/PurchaseOrder";
import { Fetch } from "../../../shared/Fetch";
import { useEffect, useState } from "react";
import { JVInputMask } from "../../../shared/JVInputMask";
import { Button } from "primereact/button";
import { IConsultnat } from "./ConsultantInformation";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { JVDropdownInput } from "../../../shared/JVDropdownInput";
import { IClientCompanyDropdown } from "../../../models/IDropdown";
import { ILogin } from "../../../models/Login";
import { JVCheckbox } from "../../../shared/JVCheckbox";
import { Billing_Cycle, Payment_Term } from "../../../models/FDropdown";

interface Iprops {
    po: IPurchaseOrder,
    toast: any,
    activeIndex: number,
    setActiveIndex: (index: number) => void,
    setNeedtoReload: (reload: boolean) => void
}
const schema = yup.object({
    // sub_Vendor_Company: yup.string().required("Company Name is required").typeError("Company Name is required"),
    sub_Vendor_Company: yup.object().shape({
        vendor_Company_ID: yup.number().min(1, "Company is required*").required("Company is required*"),
        vendor_Company_Name: yup.string().required("Company is required*")
    }),
    sub_Vendor_Contact_Person: yup.string().required("Contact Person is required").typeError("Contact Person is required"),
    sub_Vendor_Contact_Person_Email: yup.string().email("Invalid Email ID").required("Email ID is required").typeError("Email ID is required"),
    sub_Vendor_Contact_Person_Phone: yup.string().required("Phone No is required").typeError("Phone No is required"),
    sub_Vendor_Contact_Person_Ext: yup.string().nullable(),
    sub_Vendor_Contact_Person_CellNo: yup.string().nullable(),
    sub_Vendor_Billing_Cycle: yup.number().required("Billing Cycle is required").typeError("Billing Cycle is required"),
    sub_Vendor_Payment_Term: yup.number().required("Payment Term is required").typeError("Payment Term is required"),
    changeDirect: yup.boolean().nullable(),
});
const schema1 = yup.object({
    // sub_Vendor_Company: yup.string().required("Company Name is required").typeError("Company Name is required"),
    sub_Vendor_Company: yup.object().shape({
        vendor_Company_ID: yup.number().min(1, " Company is required*").required(" Company is required*"),
        vendor_Company_Name: yup.string().required()
    }),
    sub_Vendor_Contact_Person: yup.string().required("Contact Person is required").typeError("Contact Person is required"),
    sub_Vendor_Contact_Person_Email: yup.string().email("Invalid Email ID").required("Email ID is required").typeError("Email ID is required"),
    sub_Vendor_Contact_Person_Phone: yup.string().required("Phone No is required").typeError("Phone No is required"),
    sub_Vendor_Contact_Person_Ext: yup.string().nullable(),
    sub_Vendor_Contact_Person_CellNo: yup.string().nullable(),
    sub_Vendor_Billing_Cycle: yup.number().required("Billing Cycle is required").typeError("billing cycle is required"),
    sub_Vendor_Payment_Term: yup.number().required("Payment Term is required").typeError("Payment Term is required"),
    changeDirect: yup.boolean().nullable(),
});

export const SubVendorInformation = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [openInfoPODistribution, setOpenInfoPODistribution] = useState<boolean>(false);
    const [pODistributionTableData, setPODistributionTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [poSubvendorHistory, setPoSubvendorHistory] = useState({ open: false, pO_ID: 0 } as { open: boolean, pO_ID: number | undefined });
    const [subVendorCompanies, setsubVendorCompanies] = useState<Array<IClientCompanyDropdown>>();

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });


    const { control, handleSubmit, formState: { errors } } = useForm<IPurchaseOrder>({
        resolver: yupResolver(schema),
        defaultValues: {
            sub_Vendor_Company: {
                vendor_Company_ID: props.po?.sub_Vendor_ID,
                vendor_Company_Name: props.po?.pO_Sub_Vendor_Company
            },
            // sub_Vendor_Company: props.po.pO_Sub_Vendor_Company !== null ? props.po.pO_Sub_Vendor_Company : props.po.sub_Vendor_Company,
            sub_Vendor_Contact_Person: props.po.sub_Vendor_Contact_Person,
            sub_Vendor_Contact_Person_Email: props.po.sub_Vendor_Contact_Person_Email,
            sub_Vendor_Contact_Person_Phone: props.po.sub_Vendor_Contact_Person_Phone,
            sub_Vendor_Contact_Person_Ext: props.po.sub_Vendor_Contact_Person_Ext,
            sub_Vendor_Contact_Person_CellNo: props.po.sub_Vendor_Contact_Person_CellNo,
            sub_Vendor_Billing_Cycle: props.po.sub_Vendor_Billing_Cycle,
            sub_Vendor_Payment_Term: props.po.sub_Vendor_Payment_Term,
            changeDirect: false,
        },
        shouldFocusError: false
    });

    const { control: control1, handleSubmit: handleSubmit1, formState: { errors: error1 } } = useForm<IPurchaseOrder>({
        resolver: yupResolver(schema1),
        defaultValues: {
            //sub_Vendor_Company: props.po.pO_Sub_Vendor_Company !== null ? props.po.pO_Sub_Vendor_Company : props.po.sub_Vendor_Company,
            sub_Vendor_Company: {
                vendor_Company_ID: props.po.sub_Vendor_Company !== null ? props.po?.sub_Vendor_ID : 0,
                vendor_Company_Name: props.po.sub_Vendor_Company !== null ? props.po?.pO_Sub_Vendor_Company : ""
            },
            sub_Vendor_Contact_Person: props.po.sub_Vendor_Contact_Person,
            sub_Vendor_Contact_Person_Email: props.po.sub_Vendor_Contact_Person_Email,
            sub_Vendor_Contact_Person_Phone: props.po.sub_Vendor_Contact_Person_Phone,
            sub_Vendor_Contact_Person_Ext: props.po.sub_Vendor_Contact_Person_Ext,
            sub_Vendor_Contact_Person_CellNo: props.po.sub_Vendor_Contact_Person_CellNo,
            sub_Vendor_Billing_Cycle: props.po.sub_Vendor_Billing_Cycle,
            sub_Vendor_Payment_Term: props.po.sub_Vendor_Payment_Term,
            changeDirect: false
        },
        shouldFocusError: false
    });

    const [consultantInfo, setConsultantInfo] = useState<IConsultnat>();
    const [disablePaymentsTerm, setDisablePaymentsTerm] = useState(false);
    const loadConsultantData = async () => {
        const response = await Fetch("Consultant_Mast/byId", "GET", null, `consultant_id=${props.po.consultant_ID}`, props.toast);
        if (response) {
            const data: IConsultnat = await response.json();
            setConsultantInfo(data);
            if (data.tax_Term === "C2C All Inclusive" || data.tax_Term === "C2C with Benefits") {
                setDisablePaymentsTerm(true);
            } else {
                setDisablePaymentsTerm(false);
            }
        }
    }
    useEffect(() => { if (props.po.consultant_ID) loadConsultantData(); }, [props.po.consultant_ID]);


    const saveToDB = async (body: any) => {
        setLoading(true);
        body.sub_Vendor_Company = body.sub_Vendor_Company?.vendor_Company_Name
        body.pO_ID = props.po.pO_ID;
        const changeDirectNumber = body.changeDirect === true ? 1 : 0;
        delete body.changeDirect;
        const response = await Fetch("vwPODetails/details", "POST", body, `tb=${3}&changeDirect=${changeDirectNumber}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', content: "Saved Successfully" });
            props.setActiveIndex(props.activeIndex + 1);
            props.setNeedtoReload(true);
        }
        setLoading(false);
    }
    function onSubmit(data: IPurchaseOrder) {
        saveToDB(data);
    }

    const openPOSubvendorHistory = () => {
        setPoSubvendorHistory({ open: false, pO_ID: 0 });
    }

    const pStartDate = (rowData: any) => {
        let date;
        if (rowData.project_Start_Date) date = format(new Date(rowData.project_Start_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const pEndDate = (rowData: any) => {
        let date;
        if (rowData.pDate) date = format(new Date(rowData.pDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const loadPOIncDistribution = async () => {
        setPODistributionTableData({ tableData: pODistributionTableData.tableData, loading: true });
        const response = await Fetch("vwPODetails/getPOSubvendorHistory", "GET", null, `PO_ID=${props.po.pO_ID}`, props.toast);
        if (response) {
            const data: Array<any> = await response.json();
            setPODistributionTableData({ tableData: data, loading: false });
            /*
            
            */
        } else {
            setPODistributionTableData({ tableData: pODistributionTableData.tableData, loading: false });
        }
    }
    const loadsubClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/sub_vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setsubVendorCompanies(data);
        }
    }

    const completeMethodSubVendor = (event: { query: string }) => {
        loadsubClientCompanies(event.query);
    }

    return (
        <div className='w-11 m-auto mt-2'>
            {disablePaymentsTerm && <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
                {/* <JVInput required column={3} label="Company Name" control={control} name="sub_Vendor_Company" error={errors.sub_Vendor_Company?.message} /> */}
                <JVDropdownInput column={3} required label="Sub Vendor" completeMethod={completeMethodSubVendor} control={control} name="sub_Vendor_Company" options={subVendorCompanies} error={errors.sub_Vendor_Company?.vendor_Company_ID?.message} optionLabel="vendor_Company_Name" placeholder="Search Sub Vendor" />

                <JVInput required column={3} label="Contact Person" control={control} name="sub_Vendor_Contact_Person" error={errors.sub_Vendor_Contact_Person?.message} />
                <JVInput required column={3} label="Email ID" control={control} name="sub_Vendor_Contact_Person_Email" error={errors.sub_Vendor_Contact_Person_Email?.message} />

                <JVInputMask required mask="(999) 999-9999" column={3} label="Phone No" control={control} name="sub_Vendor_Contact_Person_Phone" error={errors.sub_Vendor_Contact_Person_Phone?.message} />
                <JVInputMask mask="(999) 999-9999" column={3} label="Ext No" control={control} name="sub_Vendor_Contact_Person_Ext" />
                <JVInputMask mask="(999) 999-9999" column={3} label="Cell No" control={control} name="sub_Vendor_Contact_Person_CellNo" />

                <JVDropdown required column={3} label="Billing Cycle" control={control} name="sub_Vendor_Billing_Cycle" options={Billing_Cycle} optionLabel="name" optionValue="id" placeholder="Select Billing Cycle" error={errors.sub_Vendor_Billing_Cycle?.message} />
                <JVDropdown required column={3} label="Payment Term" control={control} name="sub_Vendor_Payment_Term" options={Payment_Term} optionLabel="name" optionValue="id" placeholder="Select Payment Term" error={errors.sub_Vendor_Payment_Term?.message} />
                {(_roles.includes(1) || _roles.includes(47)) && <JVCheckbox column={6} label="Don't Create New PO" control={control} name="changeDirect" />}
                <div className="field col-12 md:col-4">
                    <label htmlFor="">&nbsp;</label>
                    <Button loading={loading} type="submit" label='SAVE & NEXT'></Button>
                </div>
            </form>}
            {!disablePaymentsTerm && <form onSubmit={handleSubmit1(onSubmit)} className="p-fluid formgrid grid mt-3">
                <JVDropdownInput column={3} required label="Sub Vendor" completeMethod={completeMethodSubVendor} control={control1} name="sub_Vendor_Company" options={subVendorCompanies} error={error1.sub_Vendor_Company?.vendor_Company_ID?.message} optionLabel="vendor_Company_Name" placeholder="Search Sub Vendor" />

                {/* <JVInput required column={3} label="Company Name" control={control1} name="sub_Vendor_Company" error={error1.sub_Vendor_Company?.message} /> */}
                <JVInput required column={3} label="Contact Person" control={control1} name="sub_Vendor_Contact_Person" error={error1.sub_Vendor_Contact_Person?.message} />
                <JVInput required column={3} label="Email ID" control={control1} name="sub_Vendor_Contact_Person_Email" error={error1.sub_Vendor_Contact_Person_Email?.message} />

                <JVInputMask required mask="(999) 999-9999" column={3} label="Phone No" control={control1} name="sub_Vendor_Contact_Person_Phone" error={error1.sub_Vendor_Contact_Person_Phone?.message} />
                <JVInputMask mask="(999) 999-9999" column={3} label="Ext No" control={control1} name="sub_Vendor_Contact_Person_Ext" />
                <JVInputMask mask="(999) 999-9999" column={3} label="Cell No" control={control1} name="sub_Vendor_Contact_Person_CellNo" />

                <JVDropdown required column={3} label="Billing Cycle" control={control1} name="sub_Vendor_Billing_Cycle" options={Billing_Cycle} optionLabel="name" optionValue="id" placeholder="Select Billing Cycle" error={error1.sub_Vendor_Billing_Cycle?.message} />
                <JVDropdown required column={3} label="Payment Term" control={control1} name="sub_Vendor_Payment_Term" options={Payment_Term} optionLabel="name" optionValue="id" placeholder="Select Payment Term" error={error1.sub_Vendor_Payment_Term?.message} />
                {(_roles.includes(1) || _roles.includes(47)) && <JVCheckbox column={6} label="Don't Create New PO" control={control} name="changeDirect" />}
                <div className="field col-12 md:col-4">
                    <label htmlFor="">&nbsp;</label>
                    <Button loading={loading} type="submit" label='SAVE & NEXT'></Button>
                </div>
            </form>}
            <Button icon="pi pi-history" type="button" className="p-button-rounded p-button-success mb-2" aria-label="see details" onClick={() => { setPoSubvendorHistory({ open: true, pO_ID: props.po.pO_ID }); loadPOIncDistribution() }}  ></Button>
            <Dialog visible={poSubvendorHistory.open} style={{ width: '80vw' }} header="Sub Vendor History" modal className="p-fluid" onHide={openPOSubvendorHistory} maximizable>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    stripedRows resizableColumns showGridlines columnResizeMode="expand"
                    size="small"

                    value={pODistributionTableData.tableData}
                    emptyMessage="No Data found."
                    loading={pODistributionTableData.loading}>
                    <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                    <Column field="sub_Vendor_Company" header="Sub Vendor Company" />
                    <Column field="sub_Vendor_Contact_Person" header="Contact Person" />
                    <Column field="sub_Vendor_Contact_Person_Email" header="Email" />
                    <Column field="sub_Vendor_Phone" header="Sub Vendor Phone" />
                    <Column field="project_Start_Date" header="Project Start Date" body={pStartDate} />
                    <Column field="project_End_Date" header="Project End Date" body={pEndDate} />
                    <Column field="created_On" header="Created On" body={(rowData: any) => <p>{`${new Date(rowData?.created_On || "").toDateString()}`}</p>} />
                    <Column field="created_By" header="Created By" />

                </DataTable>
            </Dialog>

        </div>
    );
}